export default __webpack_public_path__ + "static/media/scores.1307089b.svg";